import React from "react";

const PageNotFound: React.FunctionComponent = () => <>PAGE NOT FOUND</>;

export default PageNotFound;
